import { Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import PillVariant, {
	getPillBorderColor,
	getPillLabelColor,
	getPillBackgroundColor,
} from '~enums/pillVariant';
import { Dimens } from '~themes';

interface Props {
	label: string;
	variant?: PillVariant;
	size?: 'sm' | 'md';
}

const Pill = ({ label, variant = PillVariant.Gray, size = 'md' }: Props) => {
	const { palette } = useTheme();
	const backgroundColor = getPillBackgroundColor(variant, palette);
	const borderColor = getPillBorderColor(variant, palette);
	const textColor = getPillLabelColor(variant, palette);
	const px = size === 'sm' ? Dimens.spacingSm : Dimens.spacingMd;
	const py = size === 'sm' ? Dimens.spacing3xs : Dimens.spacing2xs;
	const fontSize = size === 'sm' ? 'label2xs' : 'labelXs';

	return (
		<Box
			sx={{
				borderRadius: Dimens.radiusFull,
				border: `1px solid ${borderColor}`,
				backgroundColor: backgroundColor,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				px: px,
				py: py,
			}}
		>
			<Typography variant={fontSize} color={textColor}>
				{label}
			</Typography>
		</Box>
	);
};

export default Pill;
